"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ramda = require("ramda");
var _funcXml = require("func-xml");
var _xmlHelpers = require("../xmlHelpers/xmlHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// String -> Node -> Boolean
var getBoolElementValue = function getBoolElementValue(name) {
  return (0, _ramda.compose)(_xmlHelpers.parseXmlBooleanDefaultFalse, (0, _xmlHelpers.getChildElementValue)(name));
};

// String -> Node -> Boolean
var getBoolAttributeValue = function getBoolAttributeValue(name) {
  return (0, _ramda.compose)(_xmlHelpers.parseXmlBooleanDefaultFalse, (0, _funcXml.attributeValue)(name));
};
var parseFieldProperties = (0, _ramda.compose)((0, _ramda.applySpec)({
  isRichText: getBoolAttributeValue('IsRichText'),
  isId: getBoolAttributeValue('IsId'),
  isAttachment: getBoolAttributeValue('IsAttachment'),
  isDate: getBoolAttributeValue('IsDate'),
  isParentId: getBoolAttributeValue('IsParentId'),
  isPerson: getBoolAttributeValue('IsPerson'),
  path: _xmlHelpers.getTextContent
}), (0, _xmlHelpers.childEl)('FormField'));
var parseField = function parseField(fieldEl) {
  return _objectSpread({
    sharePointColumn: (0, _xmlHelpers.getChildElementValue)('SharePointColumn', fieldEl)
  }, parseFieldProperties(fieldEl));
};
var getPropertiesChild = (0, _ramda.curry)(function (propertiesChild, mappingEl) {
  var propertiesEl = (0, _xmlHelpers.childEl)('Properties')(mappingEl);
  return propertiesEl ? (0, _xmlHelpers.getChildElementValue)(propertiesChild, propertiesEl) : '';
});
var getListProperties = (0, _ramda.compose)((0, _ramda.applySpec)({
  useListName: getBoolAttributeValue('useName'),
  listName: (0, _funcXml.attributeValue)('ListName'),
  listId: _xmlHelpers.getTextContent
}), (0, _xmlHelpers.childEl)('ListCollection'));
var getPropertiesFromMappingEl = (0, _ramda.applySpec)({
  name: (0, _funcXml.attributeValue)('mappingName'),
  parentMapping: getPropertiesChild('ParentMapping'),
  level: getPropertiesChild('Level'),
  isRepeating: getBoolElementValue('IsRepeating'),
  basePath: (0, _xmlHelpers.getChildElementValue)('RepeatingGroup'),
  fields: (0, _ramda.compose)((0, _ramda.map)(parseField), (0, _funcXml.childEls)('Mapping'))
});
var parseMapping = (0, _ramda.compose)(_ramda.mergeAll, (0, _ramda.juxt)([getListProperties, getPropertiesFromMappingEl]));
var parseMappings = (0, _ramda.compose)((0, _ramda.map)(parseMapping), (0, _funcXml.childEls)('Mappings'));

// [Mapping] -> { Number: [Number] }
var buildChildMap = function buildChildMap(mappings) {
  var nameToIdIndex = (0, _ramda.compose)(_ramda.fromPairs, (0, _ramda.map)(function (_ref) {
    var name = _ref.name,
      id = _ref.id;
    return [name, id];
  }))(mappings);
  return (0, _ramda.compose)((0, _ramda.map)((0, _ramda.map)((0, _ramda.prop)('id'))), (0, _ramda.groupBy)((0, _ramda.prop)('parentMapping')), (0, _ramda.map)((0, _ramda.evolve)({
    parentMapping: (0, _ramda.prop)(_ramda.__, nameToIdIndex)
  })), (0, _ramda.filter)((0, _ramda.prop)('parentMapping')))(mappings);
};
var processMappings = function processMappings(mappings) {
  var mappingsWithIds = mappings.map(function (m, index) {
    return _objectSpread(_objectSpread({}, m), {}, {
      id: index
    });
  });
  var childMap = buildChildMap(mappingsWithIds);
  return (0, _ramda.compose)((0, _ramda.indexBy)((0, _ramda.prop)('id')), (0, _ramda.map)((0, _ramda.dissoc)('parentMapping')), (0, _ramda.map)(function (m) {
    return _objectSpread(_objectSpread({}, m), {}, {
      children: childMap[m.id] || [],
      isTop: !m.parentMapping
    });
  }))(mappingsWithIds);
};
var getMappings = (0, _ramda.compose)(processMappings, parseMappings);
var parseSharePointMappings = (0, _ramda.compose)(function (m) {
  return _objectSpread(_objectSpread({}, m), {}, {
    lastId: (0, _ramda.keys)(m.mappings).length
  });
}, (0, _ramda.applySpec)({
  schemaVersion: (0, _funcXml.attributeValue)('schemaVersion'),
  sharePointSiteUrl: (0, _xmlHelpers.getChildElementValue)('SharePointListURL'),
  mappings: getMappings
}), (0, _ramda.prop)('documentElement'));
var _default = exports["default"] = parseSharePointMappings;